(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/suspension-message/assets/javascripts/suspension-message.js') >= 0) return;  svs.modules.push('/components/accountservices/suspension-message/assets/javascripts/suspension-message.js');
"use strict";

(function (svs) {
  svs = svs || {};
  svs.accountservices = svs.accountservices || {};
  svs.accountservices.suspension_message = svs.accountservices.suspension_message || {};
  const logger = svs.core.log.getLogger('components:suspension-message');
  function showDialog(message, callback) {
    const dialog = new svs.ui.dialog.Confirm({
      branding: svs.ui.dialog.branding.TUR,
      icon: 'spelpaus',
      type: svs.ui.dialog.type.CONFIRM,
      allowDimmerClick: false,
      title: 'Spelpaus',
      message: [{
        type: svs.ui.dialog.message.TEXT,
        text: message
      }],
      actions: [{
        title: 'Ok',
        callback: () => {
          dialog.close();
          callback();
        }
      }]
    });
    svs.ui.dialog.api.add(dialog);
  }

  function showSuspensionEndMessage(callback) {
    const options = {
      method: 'GET',
      path: '/player/1/suspensionhistory?count=1&key=0'
    };
    const successFn = function (response) {
      if (svs.core.detect.tenant('tb')) {
        response.suspensions = response.suspensions.filter(value => {
          if (value.product.toUpperCase() === 'POKER') {
            return false;
          }
          return true;
        });

        if (response.suspensions.length === 0) {
          callback();
          return;
        }
      }
      showDialog(svs.accountservices.suspension_message.templates.end_message(response), callback);
    };
    const errorFn = function () {
      showDialog(svs.accountservices.suspension_message.templates.end_message(), callback);
    };
    svs.core.jupiter.call(options, successFn, errorFn);
  }

  function showSuspensionMessage(callback) {
    const options = {
      method: 'GET',
      path: '/player/1/suspensions'
    };
    const successFn = function (response) {
      response.suspensions.sort((a, b) => {
        if (a.isTerminable === b.isTerminable) {
          return 0;
        } else if (a.isTerminable) {
          return 1;
        }
        return -1;
      });

      if (svs.core.detect.tenant('tb')) {
        response.suspensions = response.suspensions.filter(value => {
          if (value.product.toUpperCase() === 'POKER') {
            return false;
          }
          return true;
        });

        if (response.suspensions.length === 0) {
          callback();
          return;
        }
      }

      const message = svs.accountservices.suspension_message.templates.message(response);
      if (message.length > 0) {
        showDialog(message, callback);
      } else {
        logger.info('Got suspension notification but no suspensions from api.');
        errorFn();
      }
    };
    const errorFn = function () {
      const message = "Du har en spelpaus aktiv.<br>L\xE4s mer <a href=\"".concat(svs.core.urlMapping.get('gamingResponsibilityPause'), "\">h\xE4r</a>");
      showDialog(message, callback);
    };
    svs.core.jupiter.call(options, successFn, errorFn);
  }
  svs.accountservices.suspension_message.showSuspensionMessage = showSuspensionMessage;
  svs.accountservices.suspension_message.showSuspensionEndMessage = showSuspensionEndMessage;
})(svs);

 })(window);